import React, { useState, useEffect, useCallback } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { useDispatch, useSelector } from "react-redux";
import { rosterConfigAction } from "../../../Store/RosterConfig";
import Checkbox from "@mui/material/Checkbox";
import CloseIcon from "@mui/icons-material/Close";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import DoneIcon from "@mui/icons-material/Done";
import Modal from "@mui/material/Modal";
import { Slide, Typography } from "@mui/material";
import classes from "./ConfigInputs.module.css";
import {
  techEquipSolution,
  getdistributionType,
} from "../../../services/userServices";
import AsttButton from "components/AsttButton/AsttButton";
import AsttButtonLight from "components/ASTTButtonLight/AsttButtonLight";
import moment from "moment";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const useStyles = (theme) => ({
  dateYellow: {
    border: "1px solid #ffbf00",
    borderRadius: "5px",
  },
  borderGreen: {
    border: "1px solid #07b40c",
    borderRadius: "5px",
  },
  borderBlue: {
    border: "1px solid #0086d0",
    borderRadius: "5px",
  },
});

const formatTime = (time) => moment(time || "00:00", "hh:mm A").format("HH:mm");

const ConfigInputs = (props) => {
  const componentClass = useStyles();
  const { t } = useTranslation(["rosterConfig"]);
  const [techEquipmentSolutionOptions, setTechEquipmentSolutionOptions] =
    useState([]);
  const [distriutionTypeOptions, setDistriutionTypeOptions] = useState([]);
  const [networkTypeOptions, setNetworkTypeOptions] = useState([]);
  const [originalData, setOriginalData] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState([]);

  const remoteEmployeeBYODSRWwGP =
    "Remote Employee: BYOD + SRW w/Global Protect";
  const remoteEmployeeBYODSSDwGP =
    "Remote Employee: BYOD + SSD w/Global Protect";
  const remoteEmployeeTTECComputer3AgentBuild =
    "Remote Employee: TTEC Computer (3.0 Agent Build) w/Global Protect";
  const remoteEmployeeTTECComputerwGP =
    "Remote Employee: TTEC Computer (Windows Agent Build) w/Global Protect";
  const remoteEmployeeClientOwnedEquipment =
    "Remote Employee: Client Owned Equipment";
  const brickAndMotarsTTECComputers = "Brick and Mortar: TTEC Computers";

  const [allConfigInputs, setAllConfigInputs] = useState([
    {
      name: t("TCI Zoom Link (OG)") + ":",
      id: "tciZoomLink",
      border: "border-yellow",
      placeholder: "Max 300 characters allowed",
      max: 300,
      val: "",
      display: true,
    },
    {
      name: t("TCI Zoom PW (OG)") + ":",
      id: "tciZoomPw",
      border: "border-yellow",
      placeholder: "Max 30 characters allowed",
      max: 30,
      val: "",
      display: true,
    },
    {
      name: t("TCI Recovery Zoom Link (OG)") + ":",
      id: "tciRecoveryZoomLink",
      border: "border-yellow",
      placeholder: "Max 300 characters allowed",
      max: 300,
      val: "",
      display: true,
    },
    {
      name: t("TCI Recovery Zoom PW (OG)") + ":",
      id: "tciRecoveryZoomPw",
      border: "border-yellow",
      placeholder: "Max 30 characters allowed",
      max: 30,
      val: "",
      display: true,
    },
    {
      name: t("TTD Zoom Link") + ":",
      id: "ttdZoomLink",
      border: "border-yellow",
      placeholder: "Max 300 characters allowed",
      max: 300,
      val: "",
      display: true,
    },
    {
      name: t("TTD Zoom PW (OG)") + ":",
      id: "ttdZoomPw",
      border: "border-yellow",
      placeholder: "Max 30 characters allowed",
      max: 30,
      val: "",
      display: true,
    },
    {
      name: t("TTD Recovery Zoom Link (OG)") + ":",
      id: "ttdRecoveryZoomLink",
      border: "border-yellow",
      placeholder: "Max 300 characters allowed",
      max: 300,
      val: "",
      display: true,
    },
    {
      name: t("TTD Recovery Zoom PW (OG)") + ":",
      id: "ttdRecoveryZoomPw",
      border: "border-yellow",
      placeholder: "Max 30 characters allowed",
      max: 30,
      val: "",
      display: true,
    },
    {
      name: t("TTF Zoom Link (LD)") + ":",
      id: "ttfZoomLink",
      border: "border-blue",
      placeholder: "Max 300 characters allowed",
      max: 300,
      val: "",
      display: true,
    },
    {
      name: t("TTF Zoom PW") + ":",
      id: "ttfZoomPw",
      border: "border-blue",
      placeholder: "Max 30 characters allowed",
      max: 30,
      val: "",
      display: true,
    },

    {
      name: t("TTF Zoom Host Key (LD)") + ":",
      id: "ttfHostKey",
      border: "border-blue",
      placeholder: "Max 30 characters allowed",
      max: 30,
      val: "",
      display: true,
    },
  ]);

  const [allDate, setAllDate] = useState([
    {
      name: t("ACC Date/Time"),
      id: "accDate",
      disabled: false,
      na: "accna",
      val: "",
      display: true,
    },
    {
      name: t("TCI Date/Time (OG)") + ":",
      id: "tciDate",
      disabled: false,
      na: "tcina",
      val: "",
      border: componentClass.dateYellow,
      display: true,
    },
    {
      name: t("TCI Recovery Date/Time (OG)") + ":",
      id: "tciRecoveryDate",
      disabled: false,
      na: "tciRecoveryNA",
      val: "",
      border: componentClass.dateYellow,
      display: true,
    },
    {
      name: t("TTD/BOT Date/Time(OG)") + ":",
      id: "ttdBotDate",
      disabled: false,
      na: "techTestNA",
      val: "",
      border: componentClass.dateYellow,
      display: true,
    },
    {
      name: t("TTD Recovery Date/Time (OG)") + ":",
      id: "ttdRecoveryDate",
      disabled: false,
      na: "techTestRecoveryNA",
      val: "",
      border: componentClass.dateYellow,
      display: true,
    },
    {
      name: t("TTF Date/Time (LD)") + ":",
      id: "ttfDate",
      disabled: false,
      na: "ttfna",
      val: "",
      border: componentClass.borderBlue,
      display: true,
    },
    {
      name: t("Product Training Date/Time (LD)") + ":",
      id: "productTrainingDate",
      disabled: false,
      na: "productTrainingNa",
      val: "",
      border: componentClass.borderBlue,
      display: true,
    },
    {
      name: t("Nesting Date/Time (LD)") + ":",
      id: "nestingDate",
      disabled: false,
      na: "nestingNA",
      val: "",
      border: componentClass.borderBlue,
      display: true,
    },
    {
      name: t("Nesting End Date/Time (LD)") + ":",
      id: "nestingEndDate",
      na: "nestingNA",
      disabled: false,
      val: "",
      border: componentClass.borderBlue,
      display: true,
    },
    {
      name: "*" + t("Production Start Date (GWFM)") + ":",
      id: "productionStartDate",
      disabled: false,
      val: "",
      border: componentClass.borderGreen,
      display: true,
    },
  ]);

  const rosterConfig = useSelector((state) => state.rosterConfig);
  useEffect(() => {
    setOriginalData(rosterConfig);
  }, []);

  const dispatch = useDispatch();

  const setupInputsDisplay = (askNowTdt, isTechEquipSolutionChange = false) => {
    let allDateCopy = allDate;
    let allConfigInputsCopy = allConfigInputs;

    if (
      askNowTdt === remoteEmployeeBYODSRWwGP ||
      remoteEmployeeBYODSSDwGP ||
      remoteEmployeeTTECComputer3AgentBuild
    ) {
      allDateCopy[3].display = false;
      allDateCopy[4].display = false;
      allDateCopy[1].display = true;
      allDateCopy[2].display = true;

      allConfigInputsCopy[0].display = true;
      allConfigInputsCopy[1].display = true;
      allConfigInputsCopy[2].display = true;
      allConfigInputsCopy[3].display = true;

      allConfigInputsCopy[4].display = false;
      allConfigInputsCopy[5].display = false;
      allConfigInputsCopy[6].display = false;
      allConfigInputsCopy[7].display = false;
    }

    if (askNowTdt === remoteEmployeeTTECComputerwGP) {
      allDateCopy[3].display = true;
      allDateCopy[4].display = true;
      allConfigInputsCopy[4].display = true;
      allConfigInputsCopy[5].display = true;
      allConfigInputsCopy[6].display = true;
      allConfigInputsCopy[7].display = true;

      allDateCopy[1].display = false;
      allDateCopy[2].display = false;

      allConfigInputsCopy[0].display = false;
      allConfigInputsCopy[1].display = false;
      allConfigInputsCopy[2].display = false;
      allConfigInputsCopy[3].display = false;
    }
    if (askNowTdt === null) {
      for (const all of allDateCopy) {
        all.display = true;
      }

      for (const all of allConfigInputsCopy) {
        all.display = true;
      }
    }
    if (
      askNowTdt === remoteEmployeeClientOwnedEquipment ||
      askNowTdt === brickAndMotarsTTECComputers
    ) {
      for (const all of allDateCopy) {
        all.display = true;
      }

      for (const all of allConfigInputsCopy) {
        all.display = true;
      }
    }

    setAllDate(allDateCopy);
    setAllConfigInputs(allConfigInputsCopy);
    if (isTechEquipSolutionChange) {
      validateForExistingData(allDateCopy, allConfigInputsCopy);
    }
  };

  const fetchTechEquipmentSolutions = async () => {
    const techEquipSol = await techEquipSolution();

    if (techEquipSol.status === true) {
      setTechEquipmentSolutionOptions(techEquipSol.data);
      if (props.type !== "edit" && rosterConfig.techEquipmentSolution === "") {
        dispatch(
          rosterConfigAction.techEquipmentSolution(
            techEquipSol.data[0].TechEquipmentSolutionId,
          ),
        );
      } else {
        if (rosterConfig.techEquipmentSolution === "") {
          dispatch(
            rosterConfigAction.techEquipmentSolution(
              techEquipSol.data[0].TechEquipmentSolutionId,
            ),
          );
        }
        let data = techEquipSol.data.filter(
          (item) =>
            item.TechEquipmentSolutionId === rosterConfig.techEquipmentSolution,
        );

        const askNowTdt =
          data.length > 0 ? data[0]["tdt.AskNowTDT"] : undefined;

        setupInputsDisplay(askNowTdt);
      }
    }
  };

  const fetchDistributionTypes = async () => {
    const distributionType = await getdistributionType();
    if (distributionType.status === true) {
      setDistriutionTypeOptions(distributionType.data);
      if (props.type !== "edit" && rosterConfig.distributionType === "") {
        dispatch(
          rosterConfigAction.updateDistributionType(
            distributionType.data[0].DistributionTypeId,
          ),
        );
      }
    }
  };

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      try {
        await fetchTechEquipmentSolutions();

        if (cancelled) return;

        await fetchDistributionTypes();
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch data:", error);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, []);

  const generateDateTime = (event) => {
    let currentDate = new Date(event);
    const date = moment(new Date(currentDate)).format("YYYY-MM-DD");

    let hours = currentDate.getHours();
    let minutes = currentDate.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours || 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    const strTime = hours + ":" + minutes + " " + ampm;
    let obj = {
      date: date,
      time: strTime,
    };
    return obj;
  };

  const handleOgDateChange = useCallback((event, id) => {
    if (event.target.value !== "") {
      let dateObj =
        id === "productionStartDate"
          ? { date: event.target.value, time: null }
          : generateDateTime(event.target.value);
      dispatch(rosterConfigAction[id](dateObj));
    } else {
      let obj = {
        date: null,
        time: null,
      };
      dispatch(rosterConfigAction[id](obj));
    }
  }, []);

  const handleDisalbeChange = (e, id, na) => {
    if (e.target.checked) {
      let obj = {
        date: null,
        time: null,
      };
      if (id === "nestingDate") {
        dispatch(rosterConfigAction.nestingDate(obj));
        dispatch(rosterConfigAction.nestingEndDate(obj));
      } else {
        dispatch(rosterConfigAction[id](obj));
      }
    } else if (!e.target.checked && id === "nestingDate") {
      dispatch(rosterConfigAction["nestingDate"](originalData["nestingDate"]));
      dispatch(
        rosterConfigAction["nestingEndDate"](originalData["nestingEndDate"]),
      );
    } else {
      dispatch(rosterConfigAction[id](originalData[id]));
    }

    dispatch(rosterConfigAction[na](e.target.checked));
  };

  const handleInputChange = (event, name, id) => {
    dispatch(rosterConfigAction[id](event.target.value));
  };

  const handleResert = useCallback((id) => {
    let obj = {
      date: null,
      time: null,
    };
    dispatch(rosterConfigAction[id](obj));
  }, []);

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const validateForExistingData = (allDateData, allConfigInputData) => {
    let modalData = [];

    allDateData.forEach((item) => {
      if (item?.display === false) {
        modalData.push({
          ...item,
          value:
            moment.utc(rosterConfig[item.id].date).format("YYYY-MM-DD") +
            "T" +
            formatTime(rosterConfig[item.id].time),
          inputType: "date",
          showInModal: rosterConfig[item?.id].date !== null,
        });
      }
    });

    allConfigInputData.forEach((item) => {
      if (item?.display === false) {
        modalData.push({
          ...item,
          value: rosterConfig[item?.id],
          inputType: "config",
          showInModal: !!(
            rosterConfig[item?.id] !== null && rosterConfig[item?.id] !== ""
          ),
        });
      }
    });

    setModalContent(modalData);
    handleNAforEmptyFields(modalData);
    if (modalData.length > 0) {
      setModalOpen(true);
    }
  };

  const handleNAforEmptyFields = (data) => {
    data.forEach((item) => {
      if (item?.showInModal === false) {
        if (item?.inputType === "date") {
          let obj = {
            date: null,
            time: null,
          };
          if (item?.id === "nestingDate") {
            dispatch(rosterConfigAction.nestingDate(obj));
            dispatch(rosterConfigAction.nestingEndDate(obj));
          } else {
            dispatch(rosterConfigAction[item?.id](obj));
          }
          dispatch(rosterConfigAction[item?.na](true));
        } else if (item?.inputType === "config") {
          dispatch(rosterConfigAction[item?.id](null));
        }
      }
    });
  };
  const handleNAProceed = () => {
    modalContent.forEach((item) => {
      if (
        item?.inputType === "date" &&
        item?.display === false &&
        rosterConfig[item?.id].date !== null
      ) {
        let obj = {
          date: null,
          time: null,
        };
        if (item?.id === "nestingDate") {
          dispatch(rosterConfigAction.nestingDate(obj));
          dispatch(rosterConfigAction.nestingEndDate(obj));
        } else {
          dispatch(rosterConfigAction[item?.id](obj));
        }
        dispatch(rosterConfigAction[item?.na](true));
      } else if (
        item?.inputType === "config" &&
        item?.display === false &&
        rosterConfig[item?.id] !== null &&
        rosterConfig[item?.id] !== ""
      ) {
        dispatch(rosterConfigAction[item?.id](null));
      }
    });

    handleModalClose();
  };

  const handleTechEquipSolutionChange = (e) => {
    dispatch(rosterConfigAction.techEquipmentSolution(e.target.value));
    let data = techEquipmentSolutionOptions.filter(
      (item) => item.TechEquipmentSolutionId === parseInt(e.target.value),
    );

    const askNowTdt = data.length > 0 ? data[0]["tdt.AskNowTDT"] : undefined;

    setupInputsDisplay(askNowTdt, true);
  };

  const allDateConditions = (val) => {
    const isProductionStartDate = val.id === "productionStartDate";
    const isTentativeProductTrainingDate =
      val.id === "productTrainingDate" &&
      rosterConfig.istentativeproducttrainingdate === 1;
    const isConfirmedProductTrainingDate =
      val.id === "productTrainingDate" &&
      rosterConfig.istentativeproducttrainingdate === 0;
    const isTentativeTTFDate =
      val.id === "ttfDate" && rosterConfig.istentativettfdate === 1;
    const isConfirmedTTFDate =
      val.id === "ttfDate" && rosterConfig.istentativettfdate === 0;
    const isTentativeNestingDate =
      val.id === "nestingDate" && rosterConfig.istentativenestingdate === 1;
    const isConfirmedNestingDate =
      val.id === "nestingDate" && rosterConfig.istentativenestingdate === 0;
    return {
      isProductionStartDate,
      isTentativeProductTrainingDate,
      isConfirmedProductTrainingDate,
      isTentativeTTFDate,
      isConfirmedTTFDate,
      isTentativeNestingDate,
      isConfirmedNestingDate,
    };
  };

  return (
    <div>
      <Grid className={"m-2-20 "} container>
        <Grid className={"buttonContainer"} item xs={6}>
          {t("TechEquipSolution")}
        </Grid>
        <Grid item xs={4}>
          <select
            onChange={(e) => handleTechEquipSolutionChange(e)}
            className="dropdown-css border-purple info-section "
            value={rosterConfig.techEquipmentSolution}
            placeholder="Tech Equipment solution"
          >
            {techEquipmentSolutionOptions.map((value, index) => (
              <option
                key={value.TechEquipmentSolutionId}
                value={value.TechEquipmentSolutionId}
              >
                {value.TechEquipmentSolution}
              </option>
            ))}
          </select>
        </Grid>
        {props.type !== "edit" && (
          <Grid className="flex-display align-center" item xs={2}>
            <p className="m-l-5 ">N/A</p>
          </Grid>
        )}
      </Grid>
      {props.type === "edit" && (
        <Grid className={"m-2-20 "} container>
          <Grid className={"buttonContainer"} item xs={6}>
            {t("DistributionType")}
          </Grid>
          <Grid item xs={4}>
            <select
              onChange={(e) => {
                dispatch(
                  rosterConfigAction.updateDistributionType(e.target.value),
                );
              }}
              className="dropdown-css border-purple info-section "
              value={rosterConfig.distributionType}
              placeholder="Tech Equipment solution"
            >
              {distriutionTypeOptions.map((value, index) => (
                <option
                  key={value.DistributionTypeId}
                  value={value.DistributionTypeId}
                >
                  {value.DistributionType}
                </option>
              ))}
            </select>
          </Grid>
        </Grid>
      )}
      {props.type === "edit" && (
        <Grid className={"m-2-20 "} container>
          <Grid className={"buttonContainer"} item xs={6}>
            {t("Network Type")}
          </Grid>
          <Grid item xs={4}>
            <select
              onChange={(e) => {
                dispatch(rosterConfigAction.updateNetworkType(e.target.value));
              }}
              className="dropdown-css border-purple info-section "
              value={rosterConfig.networkType}
              placeholder="Tech Equipment solution"
            >
              {networkTypeOptions.map((value, index) => (
                <option key={value.NetworkTypeId} value={value.NetworkTypeId}>
                  {value.NetworkType}
                </option>
              ))}
            </select>
          </Grid>
          {props.type === "edit" && (
            <Grid className="flex-display align-center" item xs={2}>
              <p className="m-l-5 ">N/A</p>
            </Grid>
          )}
        </Grid>
      )}
      {allDate.map((val) => {
        const {
          isProductionStartDate,
          isTentativeProductTrainingDate,
          isConfirmedProductTrainingDate,
          isTentativeTTFDate,
          isConfirmedTTFDate,
          isTentativeNestingDate,
          isConfirmedNestingDate,
        } = allDateConditions(val);
        return (
          <>
            {val.display === true && (
              <Grid key={val.name} className={"m-2-20 height-50"} container>
                <Grid className={"buttonContainer"} item xs={6}>
                  {!isProductionStartDate && (
                    <p className={"blackColor"}>{val.name}</p>
                  )}
                  {isProductionStartDate && (
                    <p
                      className={`${
                        rosterConfig.productionStartDateRequired
                          ? "redColor"
                          : "blackColor"
                      }`}
                    >
                      {val.name}
                      <br />
                    </p>
                  )}
                </Grid>
                <Grid item xs={4}>
                  {!isProductionStartDate && (
                    <TextField
                      id={val.id}
                      type="datetime-local"
                      className={`${val.border} info-section border-radius`}
                      defaultValue=""
                      value={
                        moment
                          .utc(rosterConfig[val.id].date)
                          .format("YYYY-MM-DD") +
                        "T" +
                        formatTime(rosterConfig[val.id].time)
                      }
                      // inputFormat="DD/MM/YYYY"
                      onChange={(e) => handleOgDateChange(e, val.id)}
                      sx={{ height: 23 }}
                      disabled={rosterConfig[val.na]}
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                        classes: {
                          root: "border-yellow",
                        },
                      }}
                    />
                  )}

                  {isProductionStartDate && (
                    <TextField
                      id={val.id}
                      type="date"
                      className={`${val.border} info-section border-radius`}
                      defaultValue=""
                      value={
                        rosterConfig[val.id].date
                          ? moment(rosterConfig[val.id].date).format(
                              "YYYY-MM-DD",
                            )
                          : "YYYY-MM-DD"
                      }
                      onChange={(e) => handleOgDateChange(e, val.id)}
                      sx={{ height: 23 }}
                      disabled={rosterConfig[val.na]}
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                        classes: {
                          root: "border-yellow",
                        },
                      }}
                    />
                  )}
                </Grid>
                <Grid className={"buttonContainer height-30"} item xs={2}>
                  {val.id !== "productTrainingDate" &&
                    !isProductionStartDate && (
                      <Checkbox
                        checked={rosterConfig[val.na]}
                        onChange={(e) => {
                          if (
                            val.id === "nestingDate" ||
                            val.id === "nestingEndDate"
                          ) {
                            handleDisalbeChange(e, "nestingDate", "nestingNA");
                          } else {
                            handleDisalbeChange(e, val.id, val.na);
                          }
                        }}
                      />
                    )}
                  <CloseIcon
                    className={
                      val.id === "productTrainingDate" ||
                      val.id === "productionStartDate"
                        ? "m-l-38"
                        : null
                    }
                    onClick={(e) => handleResert(val.id)}
                  ></CloseIcon>

                  {isTentativeTTFDate && (
                    <span title="Tentative TTF Date">
                      <QuestionMarkIcon
                        sx={{ color: "red" }}
                      ></QuestionMarkIcon>
                    </span>
                  )}
                  {isConfirmedTTFDate && (
                    <span title="Confirmed">
                      <DoneIcon sx={{ color: "green" }}></DoneIcon>
                    </span>
                  )}

                  {isTentativeProductTrainingDate && (
                    <span title="Tentative Product Training Date">
                      <QuestionMarkIcon
                        sx={{ color: "red" }}
                      ></QuestionMarkIcon>
                    </span>
                  )}
                  {isConfirmedProductTrainingDate && (
                    <span title="Confirmed">
                      <DoneIcon sx={{ color: "green" }}></DoneIcon>
                    </span>
                  )}

                  {isTentativeNestingDate && (
                    <span title="Tentative nesting Date">
                      <QuestionMarkIcon
                        sx={{ color: "red" }}
                      ></QuestionMarkIcon>
                    </span>
                  )}

                  {isConfirmedNestingDate && (
                    <span title="Confirmed">
                      <DoneIcon sx={{ color: "green" }}></DoneIcon>
                    </span>
                  )}
                </Grid>
              </Grid>
            )}
          </>
        );
      })}
      {allConfigInputs.map((val, i) => (
        <>
          {val.display === true && (
            <Grid key={val.name} className={"m-2-20 height-30"} container>
              <Grid className={"buttonContainer height-30"} item xs={6}>
                {val.name}
              </Grid>
              <Grid item xs={4}>
                <input
                  name={val.name}
                  className={`dropdown-css  height-30 p-rl-10 info-section ${val.border}`}
                  placeholder={val.placeholder}
                  maxLength={val.max}
                  type="text"
                  onChange={(e) => handleInputChange(e, val.name, val.id)}
                  value={rosterConfig[val.id]}
                />
              </Grid>
            </Grid>
          )}
        </>
      ))}
      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        className={classes.modalPopup}
      >
        <Slide direction="up" in={modalOpen} mountOnEnter unmountOnExit>
          <Grid container sx={{ backgroundColor: "white", borderRadius: 3 }}>
            <Grid item xs={1}></Grid>{" "}
            <Grid item xs={11}>
              <Typography>
                <b> {t("Existing Data Cleared")} </b>
              </Typography>{" "}
            </Grid>
            {modalContent.map((item) =>
              item?.showInModal === true ? (
                <>
                  <Grid item xs={0.2}></Grid>
                  <Grid item xs={11.8} key={item?.name}>
                    <Typography>{`${item?.name} ${item?.value}`}</Typography>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={0.2}></Grid>
                  <Grid item xs={11.8} key={item?.name}>
                    <Typography>{item?.name?.replace(":", "")}</Typography>
                  </Grid>
                </>
              ),
            )}
            <Grid item xs={5.8}></Grid>
            <Grid item xs={3} sx={{ paddingBottom: 10, paddingTop: 5 }}>
              <AsttButton onClick={() => handleNAProceed()}>
                {t("PROCEED")}
              </AsttButton>
            </Grid>
            <Grid item xs={3} sx={{ paddingBottom: 10, paddingTop: 5 }}>
              <AsttButtonLight onClick={() => handleModalClose()}>
                {t("CANCEL")}
              </AsttButtonLight>
            </Grid>
            <Grid item xs={0.2}></Grid>
          </Grid>
        </Slide>
      </Modal>
    </div>
  );
};

ConfigInputs.propTypes = {
  type: PropTypes.string,
};

export default ConfigInputs;
